// GL Codes API Model
import api from '../services/api';

/**
 * Get all GL codes with pagination and search
 */
export const getGLCodes = async (page = 1, limit = 10, search = '') => {
  try {
    // Build query parameters
    const params = {
      page: page.toString(),
      limit: limit.toString()
    };
    
    if (search) {
      params.search = search;
    }
    
    const response = await api.get('/gl-codes', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching GL codes:', error);
    throw error;
  }
};

/**
 * Get all users for dropdowns
 */
export const getAllUsers = async () => {
  try {
    const response = await api.get('/users', {
      params: { pageSize: 1000 }
    });

    // The users API returns { data: { rows: [...], meta: {...} } }
    if (response.data.status === 1 && response.data.data && response.data.data.rows) {
      return {
        status: 1,
        data: response.data.data.rows
      };
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Update GL code approvers
 * @param {Object} data - Form data containing GL code and approver information
 */
export const updateGLApprovers = async (data) => {
  try {
    const response = await api.put('/gl-codes/approvers', data);
    return response.data;
  } catch (error) {
    console.error('Error updating GL approvers:', error);
    throw error;
  }
};

/**
 * Add new GL code
 * @param {Object} data - Form data for new GL code
 */
export const addGLCode = async (data) => {
  try {
    const response = await api.post('/gl-codes', data);
    return response.data;
  } catch (error) {
    console.error('Error adding GL code:', error);
    throw error;
  }
};

/**
 * Export GL codes to CSV
 */
export const exportGLCodes = async () => {
  try {
    const response = await api.get('/gl-codes/export', {
      responseType: 'text'
    });
    
    return {
      status: 1,
      data: response.data
    };
  } catch (error) {
    console.error('Error exporting GL codes:', error);
    throw error;
  }
};

/**
 * Import GL codes from CSV file
 * @param {File} file - CSV file to import
 */
export const importGLCodes = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/gl-codes/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error importing GL codes:', error);
    throw error;
  }
};
